<app-base-modal [isOpen]="isOpen" (close)="onClose()">
  <h1 header>Address select</h1>

  <div class="recipient-popup">
    <div class="recipient-popup__head">
      <div class="recipient-popup__search-wrapper">
        <input
          type="search"
          [(ngModel)]="searchString"
          placeholder="Enter search criteria"
          class="recipient-popup__search-input"
        />
        <img class="recipient-popup__search-icon" src="assets/img/search.svg" alt="" />
      </div>

      <button class="btn_primary btn_sm recipient-popup__search-btn" (click)="getContacts()">Search</button>
    </div>

    <div class="recipient-table">
      <div class="recipient-table__head">
        <div class="recipient-table__head-item">Fax Number</div>
        <div class="recipient-table__head-item">Name</div>
        <div class="recipient-table__head-item">Email</div>
      </div>

      <div class="recipient-table__body">
        <div
          *ngFor="let contact of contacts"
          class="recipient-table__body-row"
          (click)="handleSelect(contact)"
        >
          <div class="recipient-table__body-item">{{ contact.faxNumber }}</div>
          <div class="recipient-table__body-item">{{ contact.name }}</div>
          <div class="recipient-table__body-item">{{ contact.email }}</div>
        </div>
      </div>
    </div>
  </div>
</app-base-modal>
